export default "__VITE_ASSET__4033ac48__"